import { render, staticRenderFns } from "./AgentSalesChart.vue?vue&type=template&id=7ff34989&scoped=true&lang=pug&"
import script from "./AgentSalesChart.vue?vue&type=script&lang=js&"
export * from "./AgentSalesChart.vue?vue&type=script&lang=js&"
import style0 from "./AgentSalesChart.vue?vue&type=style&index=0&id=7ff34989&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff34989",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCard,VCol,VRow,VTab,VTabs})
